import { render, staticRenderFns } from "./ProjectClosureNotificationForm.vue?vue&type=template&id=e5dcd2ea&"
import script from "./ProjectClosureNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ProjectClosureNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports